import React, { useState } from 'react';
import { supabase } from '../../supabaseClient.js';
import Grid from '@mui/material/Grid2';
import { IconButton, Typography, TextField, Tooltip, Button, Stack,  MenuItem, Select, FormControl, InputLabel,  } from '@mui/material';
import useAlert from '../../alert/useAlert.js';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const UserView = ({ onBack, user, isAdmin, checkIfAdmin, userDetails }) => {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [teamName, setTeamName] = useState(user.teamName);
  const [userRole, setUserRole] = useState(user.role);

  const [profileSubmitted, setProfileSubmitted] = useState(false);
  const { setAlert } = useAlert();

  const handleProfileSubmit = async () => {
    if(!userRole) {
      setAlert('Please enter all the required fields properly', 'error');
      return;
    }
    if(user.user_id === userDetails.id && userRole !== 'Admin'){
      const { data: admins, error } = await supabase.from('team_users').select('user_id').eq('team_id', user.team_id).eq('role', 'Admin');
      if(error){
        setAlert(error.message, 'error');
        return;
      }
      if(admins.length === 1){
        setAlert('You are the last admin. Please assign another user as admin before changing your role.', 'error');
        return;
      }
    }
    await updateRole();
    if(userDetails.id === user.user_id){
      checkIfAdmin();
    }
    setAlert("Profile updated successfully!", 'success');
  };

  const updateRole = async () => {
    const { error } = await supabase.from('team_users').update({ role: userRole }).eq('user_id', user.user_id).eq('team_id', user.team_id);
    if (error) {
      setAlert(error.message, 'error');
      return
    }
  }

  const handleRoleChange = (event) => {
    setUserRole(event.target.value)
  };

  return (
    <div>
        <Grid container spacing={2}>
            <Grid size={12} sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start'}}>
                <Stack spacing={5} width={{xs: '80vw', md: '40vw'}} direction="column" alignItems="flex-start" justifyContent="center">
                    <Grid sx={{ display: "flex", alignItems: "center",}}>
                        <Tooltip title="Back to User List">
                        <IconButton onClick={onBack}>
                            <ArrowBackIcon />
                            <Typography variant="h6" sx={{color: "#29C0BB", marginLeft: '5px',}}>Back</Typography>
                        </IconButton>
                        </Tooltip>
                        <Typography variant="h5" sx={{ ml: 3, fontWeight: 'bold' }}>
                        Update Profile
                        </Typography>
                    </Grid>
                    <TextField
                        required
                        fullWidth
                        label="Your name"
                        variant="outlined"
                        focused
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter your name" 
                        sx={{ marginTop: '20px', marginBottom: '16px', backgroundColor: '#f5f5f5' }} 
                        disabled
                    />
                    <TextField
                        required
                        fullWidth
                        label="Email"
                        variant="outlined"
                        focused
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email" 
                        sx={{ marginTop: '20px', marginBottom: '16px', backgroundColor: '#f5f5f5' }} 
                        disabled
                    />
                    <TextField
                        required
                        fullWidth
                        label="Organization"
                        variant="outlined"
                        focused
                        value={teamName}
                        onChange={(e) => setTeamName(e.target.value)}
                        placeholder="Enter your organization" 
                        sx={{ marginTop: '20px', marginBottom: '16px', backgroundColor: '#f5f5f5' }} 
                        disabled
                    />
                    <FormControl fullWidth>
                        <InputLabel id="role-label">Role</InputLabel>
                        <Select
                            labelId="role-label"
                            id="role"
                            value={userRole}
                            label="Role"
                            onChange={handleRoleChange}
                            sx={{ '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#29C0BB' } }}
                        >
                            <MenuItem value="Admin">Admin</MenuItem>
                            <MenuItem value="Member">Member</MenuItem>
                            {/* <MenuItem value="Guest">Guest</MenuItem> */}
                        </Select>
                    </FormControl>
                    <Button onClick={() => { setProfileSubmitted(true); handleProfileSubmit();  }} variant="outlined" sx={{width: '100%', height: '50px', borderRadius: 30, backgroundColor: '#29C0BB', border: 0}}>
                        <Typography variant="button" sx={{color: '#FFFFFF', fontSize: '15px'}}>Submit</Typography>
                    </Button>
                </Stack>
            </Grid>
        </Grid>
    </div>
  );
};

export default UserView;

